<mat-card class="example-card">
    <mat-card-content>
        <mat-toolbar color="primary">Caractéristiques</mat-toolbar>
        <ng-template #attente>
            <br>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <div *ngIf="enregistrementTerminer;else attente"></div>

        <div class="example-table-container displayFlex">
            <div style="width: calc(50% - 10px);margin-right: 10px;">
                <mat-card class="example-card">
                    <mat-card-content>
                        <form class="example-form" #f="ngForm">
                            <mat-form-field style="margin-right: 10px">
                                <input [disabled]="disabled" matInput name="caracteristique_Model"
                                    [matAutocomplete]="caracteristiqueModel"
                                    (input)="onCaracteristiqueModelValuechange($event)" #caracteristique_Model="ngModel"
                                    [(ngModel)]="azerty" placeholder="Modèle" required>
                            </mat-form-field>
                            <mat-autocomplete #caracteristiqueModel="matAutocomplete" [displayWith]="setTextInput"
                                (optionSelected)="caracteristiqueModelSelected($event)">
                                <mat-option *ngFor="let option of listeCaracteristiqueModel" [value]="option">
                                    {{option.ecArtCarMod_Label}}
                                </mat-option>
                            </mat-autocomplete>

                            <mat-form-field style="margin-right: 10px;width:150px" class="example-full-width">
                                <input matInput [disabled]="disabled" name="ecArtCar_Label" #ecArtCar_Label="ngModel"
                                    [(ngModel)]="caracteristique.ecArtCar_Label"
                                    placeholder="Désignation Caractéristique" required>
                            </mat-form-field>
                            <mat-checkbox style="margin-right: 10px" [disabled]="disabled" checked="checked"
                                name="ecArtCarModFiltre" [(ngModel)]="caracteristique.ecArtCarMod_Filtre">
                                existe dans filter

                            </mat-checkbox>
                            <span class="button-row">
                                <button type="submit" (click)="ajouter(f)" [disabled]="disabled" class="bet_time"
                                    mat-raised-button color="primary">Ajouter</button>
                            </span>
                        </form>
                        <div fxLayout="row" fxLayoutAlign="space-between none" >
                            <mat-form-field >
                                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                            </mat-form-field>
                            <div>
                                <!-- <span style="margin-right: 10px" class="button-row">
                                    <button (click)="modifier(rowSelected)" mat-raised-button
                                        class="colorGreen">Modifier</button>
                                </span> -->
                                <span class="button-row">
                                    <button [disabled]="disabledBtnSupprimer" (click)="supprimer()" mat-raised-button class="colorReed">Supprimer</button>
                                </span>
                            </div>
                            
                        </div>
                        <table id="tablecaracteristiques" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                            <ng-container matColumnDef="ecArtCar_Id">
                                <th mat-header-cell *matHeaderCellDef> Code </th>
                                <td mat-cell *matCellDef="let element"> {{element.ecArtCar_Id}} </td>
                            </ng-container>
                            <ng-container matColumnDef="ecArtCar_Label">
                                <th mat-header-cell *matHeaderCellDef> Texte </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-form-field style="margin-right: 10px" class="example-full-width">
                                        <input matInput (blur)="modifier(element)" 
                                            [name]="'caracteristiqueText2'+element.ecArtCar_Id"
                                            #ecArtCar_Label="ngModel" [(ngModel)]="element.ecArtCar_Label">
                                    </mat-form-field>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="ecArtCarMod_Filtre">
                                <th mat-header-cell *matHeaderCellDef> Afficher dans le filter </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-checkbox  name="ecArtCarMod_Filtre" (change)="modifier(element)"
                                        [(ngModel)]="element.ecArtCarMod_Filtre"></mat-checkbox>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="ecArtCarMod_Ordre">
                                <th mat-header-cell *matHeaderCellDef> Ordre </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-form-field class="example-full-width">
                                        <input matInput type="text" (blur)="modifier(element)" 
                                            [name]="'ecArtCarMod_Ordre'+element.ecArtCar_Id"
                                            #ecArtCarMod_Ordre="ngModel" [(ngModel)]="element.ecArtCarMod_Ordre">
                                    </mat-form-field>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                                (click)="selectRow($event,row)"></tr>
                        </table>
                    </mat-card-content>
                </mat-card>
            </div>
            <div style="width:50%">
                <mat-card class="example-card">
                    <mat-card-content>
                        <form class="example-form" #formValue="ngForm">                           
                            <mat-form-field style="margin-right: 10px;width:150px" class="example-full-width">
                                <input matInput [disabled]="disabled" name="ecArtCarValList_Label" #ecArtCarValList_Label="ngModel"
                                    [(ngModel)]="caracteristiqueValue.ecArtCarValList_Label"
                                    placeholder="Désignation" required>
                            </mat-form-field>

                            <span class="button-row">
                                <button type="submit" (click)="ajouterCaracteristiqueValue(formValue)"
                                    [disabled]="disabled" class="bet_time" mat-raised-button
                                    color="primary">Ajouter</button>
                            </span>
                        </form>
                        <app-liste [showFilter]="false" [heightTable]="'400'"
                            [dataSourceBrut]="datasourceCarcarteristiqueValue"
                            [displayedColumnsBrut]="columnsCarcarteristiqueValue"
                            [listBtn]="listBtnCarcarteristiqueValue"
                            (btnTable)="clickBtnHeat($event)"
                            (blurInp)="onInput($event)"></app-liste>
                    </mat-card-content>
                </mat-card>

            </div>

        </div>
    </mat-card-content>
</mat-card>